import React from 'react';
import { Routes, Route } from 'react-router-dom';
import PagosList from './PagosList';
import PagosNoteDetail from './PagosNoteDetail';
import PaymentMethodSelect from './PaymentMethodSelect';
import PaymentTransfer from './PaymentTransfer';
import PaymentResult from './PaymentResult';
import '../../adminView/billing/billing.scss';

// Sección "Pagos" del comercio. Wrapper de rutas anidadas (mismo patrón que el
// operador en CobroView): índice = listado, :id = detalle de una nota de cobro,
// :id/pagar = selección de método, :id/transferencia = transferencia manual,
// :id/resultado = comprobante / reintento.
const PagosView = () => (
  <Routes>
    <Route index element={<PagosList />} />
    <Route path=":id" element={<PagosNoteDetail />} />
    <Route path=":id/pagar" element={<PaymentMethodSelect />} />
    <Route path=":id/transferencia" element={<PaymentTransfer />} />
    <Route path=":id/resultado" element={<PaymentResult />} />
  </Routes>
);

export default PagosView;
